<script setup>
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import { useGlobalStore } from "@stores/global";
import { useTriviaStore } from "@stores/trivia";
import { navLinks } from "../utils/navLinks";

const globalStore = useGlobalStore();
const triviaStore = useTriviaStore();

const menuRef = ref(null);

onClickOutside(
    menuRef,
    () => {
        if (globalStore.menuOpen) globalStore.toggleMenu(false);
    },
    { ignore: [".header--burger"] },
);

function navigate(link) {
    const prev = globalStore.activePage;

    if (link.name === "trivia") {
        if (prev === "trivia" && triviaStore.gameState !== "intro") {
            globalStore.toggleMenu(false);
            globalStore.openModal("leaveTriviaConfirm", { payload: "trivia" });
            return;
        }
        globalStore.setPage("trivia");
        globalStore.showPanel("trivia");
        triviaStore.reset();
    } else {
        if (prev === "trivia" && triviaStore.gameState !== "intro") {
            globalStore.toggleMenu(false);
            globalStore.openModal("leaveTriviaConfirm", {
                payload: link.name,
            });
            return;
        }
        if (prev === "trivia") {
            globalStore.hidePanel("trivia");
            triviaStore.reset();
        }
        globalStore.setPage(link.name);
    }

    globalStore.toggleMenu(false);
}
</script>

<template>
    <Transition
        enter-active-class="transition-transform duration-200"
        leave-active-class="transition-transform duration-200"
        enter-from-class="translate-x-full"
        leave-to-class="translate-x-full"
    >
        <aside
            v-if="globalStore.menuOpen"
            ref="menuRef"
            class="mobile-menu border-marine-600 bg-marine-800 flex flex-col items-start justify-center border-l min-[1395px]:hidden"
        >
            <nav class="flex w-full flex-1 flex-col items-start justify-center">
                <button
                    v-for="link in navLinks"
                    :key="link.name"
                    :class="[
                        'body-lg flex h-14 w-full items-center gap-2 overflow-clip p-6 text-left font-bold tracking-[-0.32px] uppercase',
                        globalStore.activePage === link.name
                            ? 'text-yellow-400'
                            : 'text-white',
                    ]"
                    @click="navigate(link)"
                >
                    <component :is="link.icon" class="size-5" />
                    {{ link.label }}
                </button>
            </nav>
            <a
                href="https://www.expedia.com/lp/b/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
                class="body-sm border-marine-500 flex h-14 w-full items-center gap-2 overflow-clip border-t p-6 font-extrabold tracking-[0.14px] faded-text uppercase"
                @click="globalStore.toggleMenu(false)"
            >
                Terms and Conditions
            </a>
        </aside>
    </Transition>
</template>

<style scoped>
.mobile-menu {
    grid-column: -7 / -1;
    grid-row: 2 / -1;
    z-index: 200;
}
</style>
